<template>
  <div>
    <div class="con-list f-clearfix">
      <ul class="index-course f-clearfix">
        <li v-for="(item, index) in tableList" :key="index" :title="item.name">
          <div
            v-if="item.tagTitle != null"
            id="item-course-tags-b"
            :class="
              item.tagTitle == '国家精品'
                ? 'tagA'
                : item.tagTitle == '江苏省立项建设'
                ? 'tagB'
                : 'tagC'
            "
          ></div>
          <div
            v-if="item.tagTitle != null"
            id="item-course-tags"
            :class="
              item.tagTitle == '国家精品'
                ? 'tagA'
                : item.tagTitle == '江苏省立项建设'
                ? 'tagB'
                : 'tagC'
            "
          >
            <span v-if="item.tagTitle == '国家精品'">{{ item.tagTitle }}</span>
            <span v-else-if="item.tagTitle == '江苏省立项建设'">{{
              item.tagTitle
            }}</span>
          </div>
          <a :href="item.ctUrl" target="_blank">
            <div class="item-img">
              <img v-img.lazy="item.ctImgUrl" :alt="item.name" />
            </div>
            <h3>{{ item.name }}</h3>
            <div class="item-school item-teacher">
              <span class="item-school">{{ item.teacherName }}</span>
            </div>
            <div>
              <span class="item-school">{{ item.schoolName }}</span>
              <span class="item-edu"> {{ item.enrollCount || 0 }}人选课 </span>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableList: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      let par = {
        pageSize: 8,
        currentPage: 1,
      };
      this.$http
        .post("api/web/course/rank", par)
        .then((res) => {
          this.tableList = res.data.records;
        })
        .catch((msg) => {
          console.log(msg);
        });
    },
  },
};
</script>
<style lang="scss">
.index-course {
  overflow: hidden;
  margin-top: 20px;
  :nth-child(4n) {
    margin-right: 0px;
  }
  li {
    float: left;
    width: 280px;
    margin-right: 26px;
    margin-bottom: 26px;
    position: relative;
    a:hover {
      color: #2f3440;
    }
    .item-img {
      width: 280px;
      height: 160px;
      border-radius: 4px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        transition: all 0.2s ease-in-out;
      }
    }
    h3 {
      font-size: 16px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 40px;
    }
    div {
      // height: 40px;
      // line-height: 40px;
      span {
        color: #777;
        font-size: 12px;
      }
      .item-school {
        float: left;
        width: 180px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .item-edu {
        float: right;
        text-align: right;
      }
    }
    &:hover {
      cursor: pointer;
      img {
        opacity: 0.8;
        transform: scale(1.1);
        transition: all 0.4s ease-in-out;
      }
    }
  }
}
</style>
